var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _c("p", { staticClass: "nav", on: { click: _vm.toCourseList } }, [
      _c("span", { staticClass: "el-icon-arrow-left" }),
      _c("span", [_vm._v("返回")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-box" }, [
      _vm.lastRecordId
        ? _c("span", { on: { click: _vm.lastStudy } }, [_vm._v("上一课录音")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video-box" }, [
      _c(
        "video",
        {
          ref: "video",
          staticClass: "video",
          attrs: { src: _vm.record.url, controls: "controls" }
        },
        [_vm._v("\n        您的浏览器不支持 video 标签。\n      ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98abdc40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98abdc40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/recordDetail.vue
// module id = 1614
// module chunks = 0